<template>
  <div id="home">
    <!-- <div id="indexpage">
    <Head  v-if="$route.path !=='/ai'"></Head>
    <router-view  v-if="routerView"/>
  </div> -->
    <router-view v-if="routerView" />
  </div>
</template>
<script>

// import Head from "./head.vue"

import {
  mapState,
  mapActions,
  mapMutations
} from "vuex";
export default {

  data() {
    return {
      routerView: true
    };
  },
  components: {
    // Head
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.login.userInfo,
      token: (state) => state.login.token,

    }),
  },
  methods: {
    ...mapActions(["getUserInfo"]),
  },
  async created() {
    if (this.token) {
      this.routerView = false;

      await this.getUserInfo();

      this.routerView = true;
    }

  },

};
</script>

